// data
export const SET_CONFIGURATION = 'SET_CONFIGURATION'
export const SET_FRONT_PAGE = 'SET_FRONT_PAGE'
export const SET_USER = 'SET_USER'
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED'
export const REMOVE_USER = 'REMOVE_USER'
export const UPDATE_EDITIONS = 'UPDATE_EDITIONS'
export const UPDATE_SHOW_TOOLTIP = 'UPDATE_SHOW_TOOLTIP'
export const PUSH_NOTIFICATION = 'PUSH_NOTIFICATION'
export const POP_NOTIFICATION = 'POP_NOTIFICATION'

// search
export const UPDATE_SEARCH_PARAMETERS = 'UPDATE_SEARCH_PARAMETERS'
export const UPDATE_SEARCH_RESULTS = 'UPDATE_SEARCH_RESULTS'